const appInfo = {
    title: 'Admissions Diaries',
    ver: 'v1.1.07'
};
export default appInfo;

